<template>
  <el-submenu v-if="menu.children && menu.children.length >= 1" :index="'' + menu.id">
    <template slot="title">
      <i :class="menu.icon"></i>
      <span slot="title">{{ menu.name }}</span>
    </template>
    <!--    <MenuTree v-for="item in menu.children" :key="item.id" :menu="item" :class="'leftMenuItem'+item.level"></MenuTree>-->
    <MenuTree v-for="item in menu.children" :key="item.id" :menu="item" :class="getClassName(item)"></MenuTree>
  </el-submenu>
  <el-menu-item v-else :index="menu.name" @click="handleRoute(menu)">
    <i :class="menu.icon" v-if="menu.level <3"></i>
    <div class="active-menu-icon" v-show="!$store.state.app.collapse"></div>
    <span slot="title">{{ menu.name }}</span>
  </el-menu-item>
</template>

<script>
  import {getIFramePath} from '@/utils/iframe'

  export default {
    name: 'MenuTree',
    props: {
      menu: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        activeIndex: 0
      }
    },
    methods: {
      getClassName(item) {
        if (item.level === 2) {
          if (item.children.length > 0) {
            return 'leftMenuItem21';
          }
        }
        return 'leftMenuItem' + item.level;
      },
      handleRoute(menu) {
        // 如果是嵌套页面，转换成iframe的path
        let path = getIFramePath(menu.url)
        if (!path) {
          path = menu.url
        }
        let jsEvent = menu.jsEvent;
        if (jsEvent != null && jsEvent !== "") {
          eval("this." + jsEvent);
        } else {
          // 通过菜单URL跳转至指定路由
          this.$router.push("/" + path)
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  // .el-submenu, .el-menu-item {
  //   background-color: #3c4b5a44;
  // }
  .active-menu-icon {
    height: 100%;
    width: 5px;

    /**modify 二级菜单前缀色块**/
    //background-color: #00D0CF;
    position: absolute;
    left: 0;
    display: none;
  }

  .el-menu-item.is-active {
    /**modify 一级菜单背景设置**/
    color: #436EF3 !important;
    //color: #FFFFFF !important;
    //background-color: #1A2835 !important;
    //background:none !important;

    background-image: url("/static/img/home/menu_selected1.png") !important;
    background-position: right !important;
    background-repeat: no-repeat !important;
    background-size: auto 100% !important;
    height: 92px !important;

    i{
      margin-top: 35px;
    }
    span{
      vertical-align: -20px;
    }

    .active-menu-icon {
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MenuTree/index.vue